import { c as _c } from "react/compiler-runtime";
import iconUrl from "@/public/_static/logo-icon.svg";
import Image from "next/image";
export const LogoIcon = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Image src={iconUrl} width={30} height={30} alt="Fundra logo" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};